import {
  canEditOrder,
  getEditOrderRedirect,
  getRowLink,
} from '@ldt/api/order_loader/clinic';
import {
  checkOrderValidationErrors,
  getAvailableActions,
  getOrderMissingInfoMessages,
} from '@ldt/features/orders/components/order_actions/clinic';
import {
  getOrderListColumns,
  orderListSearchConfig,
} from '@ldt/features/orders/order_list/clinic';
import { getStatusFilterOptions } from '@ldt/features/orders/statuses/clinic';
import { getDefaultWorkflowOrderStatusName } from '@ldt/features/orders/statuses/workflow_shared';
import type { LdtWorkflowDefinition } from '@ldt/workflows/types';
import { SpecimenType } from 'src/types';

export const clinicWorkflow: LdtWorkflowDefinition = {
  canCreateOrder: true,
  showBillingHoldSection: true,
  showOrderingProviderSection: () => true,
  revertStatusOnSaveWithReport: true,
  orderListSearchConfig,
  supportedSpecimenTypes: new Set([
    SpecimenType.ProstateBiopsy,
    SpecimenType.ProstatePostRp,
    SpecimenType.MetastaticProstateBiopsy,
  ]),
  canEditOrder,
  getRowLink,
  getStatusDisplayName: getDefaultWorkflowOrderStatusName,
  getStatusFilterOptions,
  getEditOrderRedirect,
  getAvailableActions,
  getOrderMissingInfoMessages,
  checkOrderValidationErrors,
  getOrderListColumns,
};
